export const APP_STATE_STORAGE_KEY = "aavo_app_state";
export const LOCAL_SETTINGS_STORAGE_KEY = "local_settings";
export const MAIN_MENU_FAVORITES_STORAGE_KEY = "mainMenuFavorites";

